import { Injectable } from '@angular/core';

@Injectable()
export class EmisijaCenaService {
  getEmisijaCenaSettings() {
    return {
      additable: true,
      allFields: [this.getDatumOdSettings(), this.getDatumDoSettings()],
      completerMainAndSecond: true,
      completerMainField: 'datumOd',
      completerSecondField: 'datumDo',
      deletable: true,
      details: [],
      documentType: 'Sifarnik',
      editable: true,
      fetchObject: 'basic',
      filterFields: [],
      formSettings: {
        header: [
          {
            title: 'Podaci',
            panels: [
              {
                title: 'Panel 1',
                panelVisible: false,
                expanded: true,
                controls: [['555-555-555'], ['666-666-666']],
              },
            ],
          },
        ],
        table: ['555-555-555', '666-666-666'],
        lookupTable: [],
      },
      fromCode: 'MSEMI_CEN',
      group: 'EmisijaCena',
      idProperty: 'Id',
      inlineAdding: true,
      inlineEditing: true,
      lazyListSource: 'mainAndSecond',
      name: 'EmisijaCena',
      relations: [],
      title: '',
      type: 'emisija',
      path: 'emisija.Period',
      _id: '51073157',
    };
  }

  getDatumOdSettings() {
    return {
      additable: true,
      dateRange: false,
      dbType: 'BIGINT',
      default: true,
      editable: true,
      fieldKey: 'datumOd',
      id: '555-555-555',
      javaFieldType: 'java.util.Date',
      label: 'Period',
      mandatory: false,
      name: 'DatumOd',
      path: 'Emisija',
      type: 'date',
      width: 92,
    };
  }

  getDatumDoSettings() {
    return {
      additable: true,
      dateRange: false,
      dbType: 'BIGINT',
      default: true,
      editable: true,
      fieldKey: 'datumDo',
      id: '666-666-666',
      javaFieldType: 'java.util.Date',
      label: 'Period',
      mandatory: false,
      name: 'DatumDo',
      path: 'Emisija',
      type: 'date',
      width: 92,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/components/emisija-cena-details/emisija-cena.service.ts